import React from 'react';
import { string, bool, func, node, oneOfType } from 'prop-types';
import Dialog from '@material-ui/core/Dialog';
import IconButton from '@material-ui/core/IconButton';
import IconClose from './icons/IconClose';

const DialogTitle = ({ children, onClose, ...other }) => {
  return (
    <div className="de-dialog__header" {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          className="de-dialog__closeButton"
          onClick={onClose}
        >
          <IconClose fill="#ffffff" />
        </IconButton>
      ) : null}
    </div>
  );
};

DialogTitle.propTypes = {
  children: node,
  onClose: func,
  id: string,
};

export default function DeDialog({
  title,
  open,
  children,
  onClose,
  id = 'mri-dialog',
  className,
}) {
  return (
    <Dialog
      disableBackdropClick
      onClose={onClose}
      aria-labelledby={id}
      open={open}
      className="de-dialog"
      classes={{
        paper: className,
      }}
    >
      <DialogTitle id={id} onClose={onClose}>
        <h6 className="de-dialog__title">{title}</h6>
      </DialogTitle>
      <div className="de-dialog__body">{children}</div>
    </Dialog>
  );
}

DeDialog.propTypes = {
  title: string,
  open: oneOfType([bool, string]),
  children: node,
  onClose: func,
  id: string,
  className: string,
};
